if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
    }

    get selectedOptionValues() {
      const options = this.querySelectorAll(
        "select, .variant-picker__field input[type='radio']"
      );
      const selectedValues = new Map();

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (field.tagName.toLowerCase() === "select") {
          const selectedOption = Array.from(field.options).find(
            (opt) => opt.selected && !opt.disabled
          );
          if (selectedOption) {
            selectedValues.set(fieldName, selectedOption.dataset.optionValueId);
          }
        } else if (
          field.tagName.toLowerCase() === "input" &&
          field.type === "radio"
        ) {
          const checkedInput = field.checked ? field : null;
          if (checkedInput) {
            selectedValues.set(fieldName, checkedInput.dataset.optionValueId);
          }
        }
      });

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (!selectedValues.has(fieldName)) {
          if (field.tagName.toLowerCase() === "select") {
            const firstValidOption = Array.from(field.options).find(
              (opt) => !opt.disabled
            );
            if (firstValidOption) {
              selectedValues.set(
                fieldName,
                firstValidOption.dataset.optionValueId
              );
            }
          } else if (
            field.tagName.toLowerCase() === "input" &&
            field.type === "radio"
          ) {
            const firstInput = field;
            if (firstInput) {
              selectedValues.set(fieldName, firstInput.dataset.optionValueId);
            }
          }
        }
      });

      const result = [];
      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;
        if (selectedValues.has(fieldName)) {
          const optionValueId = selectedValues.get(fieldName);
          if (optionValueId && !result.includes(optionValueId)) {
            result.push(optionValueId);
          }
        }
      });
      return result;
    }

    getInputForEventTarget(target) {
      return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
    }

    connectedCallback() {
      this.addEventListener("change", (event) => {
        const target = this.getInputForEventTarget(event.target);
        window.FoxThemeEvents.emit(PUB_SUB_EVENTS.optionValueSelectionChange, {
          data: {
            event,
            target,
            selectedOptionValues: this.selectedOptionValues,
          },
        });
        document.dispatchEvent(
          new CustomEvent("variant:changed", {
            detail: {
              variant: this.currentVariant,
            },
          })
        );
      });
    }
  }

  customElements.define("variant-picker", VariantPicker);
}

  document.addEventListener('DOMContentLoaded', function () {
    // 1. Inject CSS
    const style = document.createElement('style');
    style.textContent = `
      .variant-picker__option-button--color.white-border {
        border: 1px solid rgba(0, 0, 0, 0.2) !important;
        transition: border 0.2s ease-in-out;
      }
    `;
    document.head.appendChild(style);

    // 2. Logic to add/remove the border
    const whiteInput = document.querySelector('input[type="radio"][value="White"]');
    if (!whiteInput) return;

    const whiteLabel = document.querySelector('label[for="' + whiteInput.id + '"]');
    const allRadios = document.querySelectorAll('input[name="' + whiteInput.name + '"]');

    const updateWhiteSwatchBorder = () => {
      if (whiteInput.checked) {
        whiteLabel.classList.remove('white-border');
      } else {
        whiteLabel.classList.add('white-border');
      }
    };

    // Initial call
    updateWhiteSwatchBorder();

    // Listen for changes
    allRadios.forEach(radio => {
      radio.addEventListener('change', updateWhiteSwatchBorder);
    });
  });